import TaxSingoItemDefault from "../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemDefault"
import TaxSingoItemInput from "../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemInput"
import TaxSingoItemInputNumber from "../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemInputNumber"
// import TaxSingoItemMemo from "../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemMemo"

export const TAX_SINGO_TYPE_LIST = [
  {
    label: '기타',
    value: 'null',
  },
  {
    label: '부가세',
    value: '부가세',
    electronicData: true,
    wetaxElectronicData: false,
  },
  {
    label: '법인세',
    value: '법인세',
    electronicData: true,
    wetaxElectronicData: true,
  },
  {
    label: '원천세',
    value: '원천세',
    electronicData: true,
    wetaxElectronicData: true,
  },
  {
    label: '종합소득세',
    value: '종합소득세',
    electronicData: true,
    wetaxElectronicData: true,
  },
  {
    label: '개별소비세',
    value: '개별소비세',
    electronicData: true,
    wetaxElectronicData: false,
  },
  {
    label: '양도소득세',
    value: '양도소득세',
    electronicData: true,
    wetaxElectronicData: true,
  },
]

export const TAX_SINGO_SCRAPING_TYPE_LIST = [
  { value: "14", label: "원천세", wetaxItem: '140004' },
  { value: "41", label: "부가세" },
  { value: "31", label: "법인세", wetaxItem: '140003' },
  { value: "10", label: "종합소득세", wetaxItem: '140001' },
  { value: "47", label: "개별소비세" },
  { value: "22", label: "양도소득세", wetaxItem: '140002' }
]
// 세금 신고 상태
export const TAX_SINGO_STATUS_LIST = [
  { label: '대기중', value: 'pending', color: 'primary' },
  { label: '진행중', value: 'in_progress', color: 'warning' },
  { label: '완료됨', value: 'completed', color: 'success' },
  { label: '종료됨', value: 'closed', color: 'secondary' },
  { label: '취소됨', value: 'cancelled', color: 'secondary' },
]

export const TAX_SINGO_DATA_TYPE_LIST = [
  {
    label: '기본',
    value: 'default',
    Component: TaxSingoItemDefault
    // check 하면 시간표기
  },
  {
    label: '입력',
    value: 'input',
    Component: TaxSingoItemInput
  },
  {
    label: '숫자',
    value: 'number',
    Component: TaxSingoItemInputNumber
  },
  // {
  //   label: '표시',
  //   value: 'string',
  //   Component: TaxSingoItemString
  // },
  // {
  //   label: '날짜',
  //   value: 'date',
  //   Component: TaxSingoItemDefault
  // },
]

export const TAX_SINGO_REPETITION_TYPE_LIST = [
  { label: "반복없음", value: 'null', requiredIncludes: null },
  { label: "매일", value: 'daily', requiredIncludes: null },
  { label: "매주", value: 'weekly', requiredIncludes: 'week' },
  { label: "매월", value: 'monthly', requiredIncludes: 'day' },
  { label: "매년", value: 'yearly', requiredIncludes: 'month,day' },
  { label: "선택 일", value: 'specificDays', requiredIncludes: 'day' },
  { label: "선택 월", value: 'specificMonths', requiredIncludes: 'month,day' },
]

export const TAX_SINGO_TAXPAYER_TYPE_LIST = [
  { label: '수임처 전체', value: 'null' },
  { label: '법인사업자', value: '법인사업자' },
  { label: '개인사업자', value: '개인사업자' },
]
export const TAX_SINGO_CONTACT_TYPES = [
  {
    label: '주담당자, 담당자',
    value: '1,2'
  },
  {
    label: '주담당자',
    value: '1'
  },
  {
    label: '담당자',
    value: '2'
  }
];

export const CORPORATE_REGISTRATION_NUMBERS = ['81', '82', '83', '84', '85', '86', '87', '88']


export const TAX_SINGO_ELECTRONIC_DATA_COLUMNS = [
  { key: "txnrmYm", label: "과세년월" },
  { key: "pymnYm", label: "지급년월" },
  { key: "stmnKndNm", label: "신고서종류" },
  { key: "rtnClNm", label: "신고구분" },
  { key: "rtnClDetailNm", label: "신고유형" },
  { key: "txprNm", label: "상호및성명" },
  { key: "txprNo", label: "사업자(주민)등록번호" },
  { key: "rcatMthdNm", label: "접수방법" },
  { key: "cvaAplnDtm", label: "접수일시" },
  { key: "rcatNo", label: "접수번호" },
  { key: "apndDcumRcpnScntTxt", label: "접수여부" },
  { key: "userId", label: "제출자ID" },
  { key: "ecabIdYn", label: "부속서류제출여부" },
  { key: "stasAmt", label: "과세기준금액" },
  { key: "ogntxSbtrPmtTxamt", label: "소득세등납부세액" },
  { key: "vatActlPmtTxamt", label: "실제납부할세액(접수증 정보)" },
  { key: "pmtYn", label: "납부 여부" },
  { key: "billYn", label: "납부서 조회 가능 여부" },
  // -pdfPath1	접수증저장경로
  // -pdfHex1	접수증Hex데이터
]
export const TAX_SINGO_WETAX_ELECTRONIC_DATA_COLUMNS = [
  { key: "regDt", label: "신고일자" },
  { key: "taxItem", label: "신고세목" },
  { key: "rptNm", label: "신고자성명" },
  { key: "assmntStatus", label: "신고상태" },
  { key: "sidoNm", label: "시도" },
  { key: "sggNm", label: "시군구" },
  { key: "regNo", label: "주민(법인)등록번호" },
  { key: "regNm", label: "성명(법인명)" },
  { key: "cmpNm", label: "상호명" },
  { key: "bizNo", label: "사업자등록번호" },
  { key: "taxAmt", label: "납부세액" },
  { key: "dueDt", label: "납기일자" },
  { key: "epayNo", label: "전자납부번호" },
  { key: "vAcct", label: "가상계좌번호" },
  // -pdfPath	납부서저장경로
  // -pdfHex	납부서hex데이터
  // -nsData	납세 데이터
]